<template>
    <div>
        <p style="font-size: larger;font-weight: bolder">发红包配置</p>
        <div style="border-style: solid;border-bottom-width: 1px"/>

        <p style="font-size: medium;font-weight: bold">开关配置</p>
        <p>
            <span>红包功能开关&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <el-switch v-model="baseConfig.redEnvelopeSwitch" @change="redEnvelopeChange($event)"
                       active-color="#13ce66" inactive-color="#ff4949"/>
        </p>

        <p style="font-size: medium;font-weight: bold">基础配置</p>
        <el-form label-width="240px" :inline="true">
            <!--<el-form-item label="单个红包免人工审核最大金额：">-->
            <!--<el-input v-model="baseConfig.auditUsdtAmountMin" style="width: max-content"/> USDT-->
            <!--</el-form-item>-->
            <el-form-item label="创建红包内红包个数限制：">
                <el-input v-model="baseConfig.quantityMax" style="width: max-content"/>
                个
            </el-form-item>
        </el-form>

        <p style="font-size: medium;font-weight: bold">红包中文海报</p>
        <el-row>
            <el-col :span="11" :offset="1">
                <span>普通红包</span>
                <upload v-model="normalRed.zh" multiple :limit="10" :data="{ language: 1, platform: 1 }"/>
            </el-col>
            <el-col :span="11" :offset="1">
                <span>新手红包</span>
                <upload v-model="newUserRed.zh" multiple :limit="10" :data="{ language: 1, platform: 1 }"/>
            </el-col>
        </el-row>

        <p style="font-size: medium;font-weight: bold">红包英文海报</p>
        <el-row>
            <el-col :span="11" :offset="1">
                <span>普通红包</span>
                <upload v-model="normalRed.en" multiple :limit="10" :data="{ language: 4, platform: 1 }"/>
            </el-col>
            <el-col :span="11" :offset="1">
                <span>新手红包</span>
                <upload v-model="newUserRed.en" multiple :limit="10" :data="{ language: 4, platform: 1 }"/>
            </el-col>
        </el-row>

        <p>
            <el-button type="success" @click="saveConfig()">红包配置保存</el-button>
        </p>

        <br/>
        <p>
            <span style="font-size: medium;font-weight: bold">币种管理</span>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button type="success" @click="(opType = 'insert'), (redInfo.support = 'false'), (showEdit = true)">新增
            </el-button>
        </p>
        <el-table :data="redList">
            <el-table-column label="币种" prop="coinType"/>
            <el-table-column label="支持红包">
                <template slot-scope="scope">
                    {{ scope.row.support ? '✔' : '❌' }}
                </template>
            </el-table-column>
            <el-table-column label="单个红包限额" prop="singleRecordAmountMax">
                <template slot-scope="scope">
                    {{ scope.row.singleRecordAmountMin }}-{{ scope.row.singleRecordAmountMax }}
                </template>
            </el-table-column>
            <el-table-column label="单次支付总额限制" prop="singleCoinAmountMax"/>
            <el-table-column label="每人24小时红包限额" prop="everyUserOneDayCoinAmountMax"/>
            <el-table-column label="审核额度最小值" prop="auditAmountMin"/>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="editOpen(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="total"
                       :page-size="10" :current-page="pageNo" @current-change="listQuery"/>

        <el-dialog title="编辑" :visible.sync="showEdit" @close="closeEdit()" width="30%">
            <el-form label-position="top">
                <el-form-item label="币种">
                    <el-input v-model="redInfo.coinType" :disabled="opType === 'update'" style="width: max-content"/>
                </el-form-item>
                <el-form-item label="是否支持红包功能">
                    <el-switch v-model="redInfo.support" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
                <el-form-item label="单个红包限额：0.0001<X<=9999999，支持4位小数">
                    <el-input placeholder="最小限额" v-model="redInfo.singleRecordAmountMin" style="width: max-content"/>
                    -
                    <el-input placeholder="最大限额" v-model="redInfo.singleRecordAmountMax" style="width: max-content"/>
                </el-form-item>
                <el-form-item label="单次支付总额限制">
                    <el-input placeholder="请输入数量限制" v-model="redInfo.singleCoinAmountMax" style="width: max-content"/>
                </el-form-item>
                <el-form-item label="每人24小时红包限额">
                    <el-input placeholder="请输入数量限制" v-model="redInfo.everyUserOneDayCoinAmountMax"
                              style="width: max-content"/>
                </el-form-item>
                <el-form-item label="审核额度最小值">
                    <el-input placeholder="红包额度达到审核条件的最小值，额度达到此值后需要进入审核流程" v-model="redInfo.auditAmountMin"
                              style="width: max-content"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeEdit()">取消</el-button>
                    <el-button type="primary" @click="saveConfigOption()">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import api from './api';
    import upload from '../../components/upload/indexMultiple';

    export default {
        name: 'index',
        components: {upload},
        data() {
            return {
                baseConfig: {
                    redEnvelopeSwitch: false,
                    quantityMax: 0,
                    // auditUsdtAmountMin: 0,
                    posterUrlNormal: '',
                    posterUrlNewUser: ''
                },
                normalRed: {zh: [], en: []},
                newUserRed: {zh: [], en: []},
                redList: [],
                total: 0,
                redInfo: {support: false},
                showEdit: false,
                opType: 'insert',
                pageNo: 1
            };
        },
        created() {
            api.baseConfig().then(response => {
                this.baseConfig = response.data;
                this.normalRed = response.data.posterUrlNormal ? JSON.parse(response.data.posterUrlNormal) : {zh: [], en: []};
                this.newUserRed = response.data.posterUrlNewUser ? JSON.parse(response.data.posterUrlNewUser) : {zh: [], en: []};
            });
            this.listQuery(1);
        },
        methods: {
            saveConfig() {
                this.baseConfig.posterUrlNormal = JSON.stringify(this.normalRed);
                this.baseConfig.posterUrlNewUser = JSON.stringify(this.newUserRed);
                api.baseConfigUpdate(this.baseConfig).then(() => this.$message.success('红包配置保存成功'));
            },
            editOpen(row) {
                this.opType = 'update';
                this.redInfo = JSON.parse(JSON.stringify(row));
                this.showEdit = true;
            },
            closeEdit() {
                this.redInfo = {};
                this.showEdit = false;
            },
            saveConfigOption() {
                if (
                    this.redInfo.singleRecordAmountMin &&
                    this.redInfo.singleRecordAmountMax &&
                    this.redInfo.singleCoinAmountMax &&
                    this.redInfo.everyUserOneDayCoinAmountMax &&
                    this.redInfo.auditAmountMin
                ) {
                    if (this.opType === 'insert') {
                        api.createRed(this.redInfo).then(() => {
                            this.$message.success('新增成功');
                            this.listQuery(1);
                            this.closeEdit();
                        });
                    }
                    if (this.opType === 'update') {
                        api.updateRed(this.redInfo).then(() => {
                            this.$message.success('修改成功');
                            this.listQuery(1);
                            this.closeEdit();
                        });
                    }
                } else {
                    this.$message.error('请完善参数信息');
                }
            },
            listQuery(val) {
                api.redList({page: val}).then(response => {
                    this.redList = response.data.list;
                    this.total = response.data.totalCount;
                });
            },
            redEnvelopeChange(val) {
                this.$confirm(val ? '是否确认开启红包功能？' : '是否确认关闭红包功能？', val ? '开启红包功能' : '关闭红包功能', {
                    type: 'warning'
                }).then(() => {
                    this.baseConfig.redEnvelopeSwitch = val;
                }).catch(() => {
                    this.baseConfig.redEnvelopeSwitch = !val;
                });
            }
        }
    };
</script>

<style scoped></style>
